/**
 * EAkte Plus API
 * API eakteplus document metadata api
 *
 * OpenAPI spec version: 1.0.1
 * Contact: ehgidencores@eulerhermes.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
	HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MetadataDefinitionEnum } from '../model/metadataDefinitionEnum';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { environment } from '../../environments/environment';


@Injectable()
export class CORSService {

	protected basePath = environment.demoApi;
	public defaultHeaders = new HttpHeaders();
	public configuration = new Configuration();

	constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
		if (basePath) {
			this.basePath = basePath;
		}
		if (configuration) {
			this.configuration = configuration;
			this.basePath = basePath || configuration.basePath || this.basePath;
		}
	}

	/**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
	private canConsumeForm(consumes: string[]): boolean {
		const form = 'multipart/form-data';
		for (const consume of consumes) {
			if (form === consume) {
				return true;
			}
		}
		return false;
	}


	/**
     * CORS \&quot;preflight\&quot; request
     * File content identified by dui CORS
     * @param dui Document Unique Identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public documentCors(dui: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
	public documentCors(dui: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	public documentCors(dui: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	public documentCors(dui: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
		let headers = this.defaultHeaders;

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
		];

		return this.httpClient.request<any>('options',`${this.basePath}/documents/${encodeURIComponent(String(dui))}`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
     * CORS \&quot;preflight\&quot; request
     * Document search get deep link preflight for CORS
     * @param searchFilterId SearchFilters Unique Identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public documentGetSearchFiltersOptions(searchFilterId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
	public documentGetSearchFiltersOptions(searchFilterId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	public documentGetSearchFiltersOptions(searchFilterId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	public documentGetSearchFiltersOptions(searchFilterId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
		let headers = this.defaultHeaders;

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
		];

		return this.httpClient.request<any>('options',`${this.basePath}/documents/searchFilters/${encodeURIComponent(String(searchFilterId))}`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
     * CORS \&quot;preflight\&quot; request
     * Document metadata preflight for the Document Unique Identifier CORS
     * @param dui Document Unique Identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public documentMetadataOptions(dui: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
	public documentMetadataOptions(dui: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	public documentMetadataOptions(dui: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	public documentMetadataOptions(dui: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
		let headers = this.defaultHeaders;

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
		];

		return this.httpClient.request<any>('options',`${this.basePath}/documents/${encodeURIComponent(String(dui))}/metadata`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
     * CORS \&quot;preflight\&quot;
     * Search document metadatas which match the filter criteria CORS
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public documentMetadatasListOptions(observe?: 'body', reportProgress?: boolean): Observable<any>;
	public documentMetadatasListOptions(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	public documentMetadatasListOptions(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	public documentMetadatasListOptions(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

		let headers = this.defaultHeaders;

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
		];

		return this.httpClient.request<any>('options',`${this.basePath}/documents/metadata/search`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
     * CORS \&quot;preflight\&quot;
     * Search document metadatas which match the filter criteria CORS
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public documentMetadatasListSearchFiltersOptions(observe?: 'body', reportProgress?: boolean): Observable<any>;
	public documentMetadatasListSearchFiltersOptions(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	public documentMetadatasListSearchFiltersOptions(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	public documentMetadatasListSearchFiltersOptions(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

		let headers = this.defaultHeaders;

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
		];

		return this.httpClient.request<any>('options',`${this.basePath}/documents/searchFilters`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
     * CORS \&quot;preflight\&quot; request
     * Upload file and create document metadata identified by dui CORS
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public documentPostCors(observe?: 'body', reportProgress?: boolean): Observable<any>;
	public documentPostCors(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	public documentPostCors(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	public documentPostCors(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

		let headers = this.defaultHeaders;

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
		];

		return this.httpClient.request<any>('options',`${this.basePath}/documents`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
     * CORS \&quot;preflight\&quot; request
     * Retrieves all versions of document metadatas CORS
     * @param dui Document Unique Identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public documentmetadataHistoryCors(dui: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
	public documentmetadataHistoryCors(dui: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	public documentmetadataHistoryCors(dui: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	public documentmetadataHistoryCors(dui: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
		let headers = this.defaultHeaders;

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
		];

		return this.httpClient.request<any>('options',`${this.basePath}/documents/${encodeURIComponent(String(dui))}/metadata/history`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
     * CORS \&quot;preflight\&quot; request
     * Retrieves the version of document metadata for Document Unique Identifier CORS
     * @param dui Document Unique Identifier
     * @param version Desired version of the metadata history identified by dui
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public documentmetadataHistoryVersionCors(dui: string, version: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
	public documentmetadataHistoryVersionCors(dui: string, version: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	public documentmetadataHistoryVersionCors(dui: string, version: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	public documentmetadataHistoryVersionCors(dui: string, version: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
		let headers = this.defaultHeaders;

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
		];

		return this.httpClient.request<any>('options',`${this.basePath}/documents/${encodeURIComponent(String(dui))}/metadata/history/${encodeURIComponent(String(version))}`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
     * CORS \&quot;preflight\&quot; request
     * Retreive the catalog values for some fields CORS
     * @param metadataDefinitionId Unique Id associated to the metadata definition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public metadatadefinitionCors(metadataDefinitionId: MetadataDefinitionEnum, observe?: 'body', reportProgress?: boolean): Observable<any>;
	public metadatadefinitionCors(metadataDefinitionId: MetadataDefinitionEnum, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
	public metadatadefinitionCors(metadataDefinitionId: MetadataDefinitionEnum, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
	public metadatadefinitionCors(metadataDefinitionId: MetadataDefinitionEnum, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
		let headers = this.defaultHeaders;

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
		];

		return this.httpClient.request<any>('options',`${this.basePath}/metadatadefinition/${encodeURIComponent(String(metadataDefinitionId))}`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

}
